import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW,
  NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
  LegacyResolvers,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields, screenInfo } from "./TroopScheduleStepFormConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";
import "./css/TroopScheduleStepForm.css";

import { useModal } from "../../common_nextgen/hooks/ModalContext";

const TroopScheduleStepForm = ({ mode }) => {
  const { TROOP_SCHEDULE_STEP, TROOP_SCHEDULE_STEP_MESSAGE } = ROUTE_PATHS;
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();

  /*let {
    selectedSchedules = [],
    previousScreen = TROOP_SCHEDULE_STEP,
    currentIndex: initialIndex = 0,
    paramsData,
    tscScheduleName,
  } = currentState;*/

  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    paramsData,
    tscScheduleName,

    lookupScreen,
    lookupParams,
    lookupMode: initialLookupMode = false,
    formData: baseFormData = {},
    navigateData,
  } = useMemo(() => {
    const {
      selectedSchedules,
      previousScreen,
      currentIndex,
      paramsData,
      tscScheduleName,
      lookupScreen,
      lookupParams,
      lookupMode,
      formData,
      navigateData,
    } = currentState;
    return {
      selectedSchedules,
      previousScreen,
      currentIndex,
      paramsData,
      tscScheduleName,
      lookupScreen,
      lookupParams,
      lookupMode,
      formData,
      navigateData,
    };
  }, [currentState]);

  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const toast = useToast();

  /* const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
     const updatedFormData = { ...formData };
     if (lookupScreen.default === "RCPLN018" && formData.planCode === "") {
       updatedFormData.planEffDate = "";
       updatedFormData.planName = "";
     }
     showModal(lookupScreen, { params }, handleReceiveData, updatedFormData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };*/

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialLookupMode,
    initialIndex: currentIndex,
    lookupScreen,
    lookupParams,
    navigateData,
    previousState,
    currentState,
    currentMode,
  });

  const handleBack = useCallback(() => {
    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  }, [currentIndex, selectedSchedules]);

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/troopScheduleDetail";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/troopScheduleDetail";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
                                    toast.current.show({
                                      severity: "info",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    });
                                  } else {
                                    toast.current.show({
                                      severity: "success",
                                      summary: "",
                                      detail: responseStatus.message,
                                      life: 3000,
                                    });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const latestCurrentState = {
          ...currentState,
          selectedSchedules: [{ ...responseData }],
          currentIndex: 0,
        };
        const updatedState = [...previousState, latestCurrentState];
        setStateVal([...updatedState]);
        navigateToPage(ROUTE_PATHS.TROOP_SCHEDULE_STEP_EDIT, [...updatedState]);
      }
      try {
        const secondApiUrl = "api/troopScheduleDetail/validateTsdTroopSchedule";
        await axios_helper_no_header("POST", secondApiUrl, responseData, null);
      } catch (validationError) {
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          validationError.data;
        if (displayErrorFields === null) {
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
        } else {
          setConstraintErrors(displayErrorFields);
        }
      }
    } }catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const navigateToStepMessage = async () => {
    console.log("Initial Form Data:", initialFormData);

    // Ensure data is fetched before navigating
    await fetchInitialData();

    // Log the specific `initialFormData` object
    console.log(initialFormData.tscStepCount);

    navigateToPage(TROOP_SCHEDULE_STEP_MESSAGE, [
      ...previousState,
      { ...currentState, currentIndex },
      {
        selectedSteps: [initialFormData],
        currentIndex: 0,
        previousScreen: location.pathname,
        paramsData: {
          tscScheduleName: initialFormData.tscScheduleName,
          tscDescription: initialFormData.tscDescription,
          tscVersion: initialFormData.tscVersion,
          tscStepCount: initialFormData.tscStepCount,
          tscCrossOverFlag: initialFormData.tscCrossOverFlag,
          tscTroopAccumCompCode: initialFormData.tscTroopAccumCompCode,
          tscDrugSpendAccumComp: initialFormData.tscDrugSpendAccumComp,
          tsdStepNumber: initialFormData.tsdStepNumber,
          tsdTroopAmount: initialFormData.tsdTroopAmount,
          tsdDrugSpend: initialFormData.tsdDrugSpend,
          tsdPlanCode: initialFormData.planCode,
          tsdPlanEffDate: initialFormData.planEffDate,
        },
      },
    ]);
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
      keyFunc.F21 = navigateToStepMessage;
      keyName.F21 = "Messages";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F21 = navigateToStepMessage;
      keyName.F21 = "Messages";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData]);

  // Fetch initial data function
  const fetchInitialData = async () => {
    const params = isAddMode(currentMode)
      ? { tscScheduleName: tscScheduleName }
      : { tsdStepNumber: selectedSchedules[currentIndex]?.tsdStepNumber };
    const url = isAddMode(currentMode)
      ? `api/troopScheduleDetail/initialFormData/${encodeURIComponent(
          screenInfo.ADD[1]
        )}`
      : `api/troopScheduleDetail/${encodeURIComponent(tscScheduleName)}`;

    try {
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        {},
        params
      );
      setInitialFormData(responseData);
    } catch (error) {
      console.error("Failed to fetch initial data:", error);
    }
  };

  useEffect(() => {
    if (
      (isAddMode(currentMode) && tscScheduleName) ||
      (!lookupMode && selectedSchedules.length)
    ) {
      fetchInitialData();
    } else {
      setInitialFormData(baseFormData);
    }
  }, [mode, currentIndex]);

  useEffect(() => {
    if (
      Object.keys(baseFormData).length &&
      JSON.stringify(baseFormData) !== JSON.stringify(initialFormData)
    ) {
      setInitialFormData(baseFormData);
    }
  }, [baseFormData]);

  const handleMessage = (event) => {
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      //setExternalMode(true);
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default TroopScheduleStepForm;